import React, { useState } from "react";
import { toast, Toaster } from "react-hot-toast";
import reasons from "./data/reasons";
import useUILanguage from "./hooks/useUILanguage";
import { langLabels, languageLabels } from "./data/langLabels"; // 已合并在 langLabels.js 中
import untranslatedPlaceholder from "./data/fallback";

const LeaveReasonGenerator = () => {
  const [current, setCurrent] = useState(null);
  const { lang: uiLang, setLang: setUiLang, uiText } = useUILanguage();

  const generate = () => {
    const allReasons = Object.values(reasons).flat();
    const random = allReasons[Math.floor(Math.random() * allReasons.length)];
    setCurrent(random);
  };

  const copy = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => toast.success(uiText.toast))
        .catch(() => fallbackCopy(text));
    } else {
      fallbackCopy(text);
    }
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // 避免跳動
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        toast.success(uiText.toast);
      } else {
        throw new Error("execCommand failed");
      }
    } catch (err) {
      toast.error("複製失敗，請手動複製！");
    } finally {
      document.body.removeChild(textarea);
    }
  };

  return (
    <div className="flex flex-col items-center text-center px-6 sm:px-8 py-14 max-w-2xl w-full mx-auto space-y-6 font-sans tracking-wide leading-relaxed">
      <Toaster />
      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
        {uiLang === "zhHans" && "不来上班™ 请假理由生成器"}
        {uiLang === "zhHant" && "不來上班™ 請假理由產生器"}
        {uiLang === "en" && "Notwork™ Leave Excuse Generator"}
        {uiLang === "ms" && "Notwork™ Penjana Alasan Cuti"}
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg shadow-sm w-full max-w-sm space-y-2">
        <label className="flex items-center text-sm font-medium text-gray-700">
          🌐 Language:
        </label>
        <select
          value={uiLang}
          onChange={(e) => setUiLang(e.target.value)}
          className="w-full py-3 px-4 rounded-xl border border-gray-300 bg-white text-base sm:text-lg text-gray-800 shadow-sm appearance-none"
        >
          {Object.entries(langLabels).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </div>
      
      {/*
      <div className="w-full max-w-xs text-left">
        <label className="block text-sm text-gray-600 mb-1">🎯 請假理由風格</label>
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="w-full py-2 px-3 rounded-xl border border-gray-300 bg-white text-sm text-gray-800 shadow-sm"
        >
          <option value="random">隨機亂抽 🎲</option>
          <option value="polite">今天想禮貌點 🍵</option>
          <option value="emotional">我情緒炸了 🧘</option>
          <option value="absurd">我不想解釋 🐸</option>
        </select>
      </div>
      */}

      <button
        onClick={() => {
          if (typeof gtag === "function") {
            gtag("event", "generate_leave_reason_click", {
              event_category: "button",
              event_label: "Generate Leave Reason",
            });
          }
          generate();
        }}
        className="bg-blue-600 hover:bg-blue-700 text-white text-lg sm:text-xl font-semibold px-8 py-4 rounded-full shadow-lg transition-transform active:scale-95"
      >
        💤 {uiText.generate}
      </button>

      {current && (
        <div className="bg-white rounded-2xl border border-gray-200 p-5 shadow-md space-y-5 w-full max-w-lg">
          {["zhHans", "zhHant", "en", "ms"].map((lang) => (
            <div key={lang} className="space-y-2">
              <p className="text-sm font-medium text-gray-600">
                {languageLabels[uiLang][lang]}：
              </p>
              <p className="text-base sm:text-lg leading-relaxed">
                {current[lang] || untranslatedPlaceholder[uiLang]}
              </p>
              <button
                onClick={() => {
                  if (typeof gtag === "function") {
                    gtag("event", "copy_reason_click", {
                      event_category: "button",
                      event_label: `Copy ${lang} Reason`,
                    });
                  }
                  copy(current[lang]);
                }}
                className="mt-1 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 px-4 py-1.5 rounded transition-all"
              >
                📋 {uiText.copy}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LeaveReasonGenerator;
